import React, {Component} from 'react';
import Grid from '@material-ui/core/Grid';
import {withStyles} from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import appTheme from '../AppTheme';
import {withRouter} from 'react-router-dom';

const styles = theme => ({
  signIn: {
    "min-height": "250px",
    "min-width": "282px",
    "max-width": "282px",
    "padding": "16px"
  },
  container: {
    marginBottom: "auto",
    marginTop: "200px",
    maxWidth: "700px",
    color: "white",
  },
  header: {
    fontWeight: 'normal',
    fontSize: '2rem',
  },
  text: {
    fontSize: '1.2rem',
    marginTop: '50px',
    marginBottom: '40px',
    lineHeight: '2.5',
    textAlign: 'center',
  },
  linkText: {
    color: '#1919f4',
    padding: '10px 20px',
    textDecoration: 'none',
    backgroundColor: 'white',
    borderRadius: '10px',
    fontSize: '1.2rem',
  },
  textField: {
    width: 250,
  },
  button: {
    "border-radius": "8px",
    width: 250,
    "margin-top": "16px",
    border: "2px solid #fff",
    '&:disabled': {
      border: "2px solid #ffffff4d",
    },
  },
  progress: {
    width: 250,
    "margin-top": "16px"
  },
  link: {
    textDecoration: "none",
  }
});

class Stub extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {classes} = this.props;
    return (
      <Grid container alignItems={"flex-start"} justify={"center"} direction={"row"} className={classes.container}>
        <h1 className={classes.header}>We've Moved!</h1>
        <p className={classes.text}>You can now manage all user reports, user accounts, and content directly in the Blank Slate Hub.</p>
        <a href='https://hub.blankslatetechnologies.com/' className={classes.linkText}>Click here to go to the Hub</a>
    </Grid>
  );
  }
}

Stub.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default appTheme(withStyles(styles)(withRouter(Stub)));
